<template>
  <div class="objective-heading" :class="levelClass">
    <div class="objective-heading-label" v-if="showQuarter">
      <b>{{ level }}</b>
      <br>
      <span>Quarter</span>
    </div>
    <h3 class="panel-title ellipsis" :title="title">{{ title || 'Objective' }}</h3>
    <div class="actions">
      <slot name="actions"/>
    </div>
  </div>
</template>

<script>
import { ObjectiveLevelValues } from '@/components/goals/common/objectives'
export default {
  name: 'ObjectiveHeading',
  props: {
    level: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    showQuarter: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    levelClass() {
      return {
        'quarter-1': this.level === ObjectiveLevelValues.QUARTER_1ST,
        'quarter-2': this.level === ObjectiveLevelValues.QUARTER_2ND,
        'quarter-3': this.level === ObjectiveLevelValues.QUARTER_3RD,
        'quarter-4': this.level === ObjectiveLevelValues.QUARTER_4TH,
        'no-quarter': this.showQuarter === false
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/variables.less';

.no-quarter {
  padding: 12px 16px;
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
  .panel-title {
    color: white;
    padding-left: 1px !important;
  }
}

.objective-heading {
  overflow: hidden;
  position: relative;
  @labelWidth: 84px;
  border-bottom: 0;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  display: flex;
  align-items: center;

  .objective-heading-label {
    flex: 0 0 auto;
    align-self: stretch;
    color: white;
    min-width: @labelWidth;
    padding: 8px 16px;
    line-height: 18px;
    letter-spacing: 0.75px;
    b {
      font-size: 20px;
      font-weight: 500;
    }
    span {
      font-weight: 300;
      font-size: 13px;
    }
  }

  .panel-title {
    flex: 1 1 auto;
    font-weight: bold;
    line-height: 18px;
    padding-left: 12px;
    padding-bottom: 4px;
  }

  .actions {
    flex: 1 1 auto;
    text-align: right;
    padding-right: 24px;
    white-space: nowrap;
  }

  &.quarter-1 {
    background-color: @tealLight;
    &.no-quarter {
      background-color: @tealObjective;
    }
    .objective-heading-label {
      background-color: @tealObjective;
    }
  }
  &.quarter-2 {
    background-color: @blueLight;
    &.no-quarter {
      background-color: @blueObjective;
    }
    .objective-heading-label {
      background-color: @blueObjective;
    }
  }
  &.quarter-3 {
    background-color: @purpleLight;
    &.no-quarter {
      background-color: @purpleObjective;
    }
    .objective-heading-label {
      background-color: @purpleObjective;
    }
  }
}
</style>
